import PropTypes from 'prop-types';

import './styles.css';

const typesCSS = {
  danger: 'bg-red-2',
  info: 'bg-blue-2',
  new: 'bg-yellow-3',
  disabled: 'bg-gray-3',
  success: 'bg-green-2',
  warning: 'bg-orange-2',
};

const StatusIndicator = ({ type, ...rest }) => (
  <span
    aria-hidden="true"
    className={`status-indicator inline-block rounded-full ${typesCSS[type]}`}
    focusable="false"
    role="img"
    {...rest}
  />
);

StatusIndicator.propTypes = {
  type: PropTypes.oneOf([
    'danger',
    'info',
    'new',
    'disabled',
    'success',
    'warning',
  ]).isRequired,
};

export default StatusIndicator;
